/* eslint-disable react/no-danger */
import { useState, useEffect } from 'react';
import { Button } from 'palette/Button';
import { Dialog } from 'palette/Dialog';
import { ModalBoxBody, ModalBoxFooter, ModalBoxHeader } from 'palette/Modal';
import { BodyText } from 'palette/Typography';
import { useActiveDeal } from '@common/ActivateDeals/hooks';
import { useFetch } from '@common/Http';
import { Spinner } from '@common/Spinner';
import { useTranslate } from '@common/Translations';
import { MODAL_ID } from '../constants';

import '../styles/ActivateDealsTermsModal.scss';

function ActivateDealsTermsModal({ visible, onClose }) {
    const translate = useTranslate();
    const [terms, setTerms] = useState(null);
    const deal = useActiveDeal();

    const { get } = useFetch();

    const makeTranslation = () => {
        const translation = deal?.trans_valid_to || translate('mdv.valid_to');
        const searchFields = ['{%end_date%}'];

        let result = translation;

        for (const trans of searchFields) {
            if (result.includes(trans)) {
                result = result.replace(trans, deal?.end_date);
            }
        }

        return result;
    };

    useEffect(() => {
        if (!terms && visible) {
            get('/{store}/{language}/terms-conditions-deals', { json: true }, undefined).then((response) => {
                setTerms(response?.text || ' ');
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [terms, visible]);

    return deal && (
        <Dialog
            className="activate-deals-terms-modal"
            id={MODAL_ID}
            size="medium"
            onClose={onClose}
        >
            <ModalBoxHeader
                subtitle={makeTranslation()}
                title={deal.name}
            />
            <ModalBoxBody>
                {!terms && <Spinner />}
                {terms && (
                    <>
                        <BodyText
                            tagName="p"
                        >
                            <span dangerouslySetInnerHTML={{ __html: deal.info }} />
                        </BodyText>
                        <BodyText
                            tagName="p"
                        >
                            <span dangerouslySetInnerHTML={{ __html: terms }} />
                        </BodyText>
                    </>
                )}
            </ModalBoxBody>
            <ModalBoxFooter>
                <Button
                    label={translate('mdv.terms_close_modal')}
                    onClick={onClose}
                />
            </ModalBoxFooter>
        </Dialog>
    );
}

export default ActivateDealsTermsModal;
